import { IAppConfig } from "./types";

export const initialState: IAppConfig = {
  eventTypes: [],
  allowIssuerPricing: false,
};
